// extracted by mini-css-extract-plugin
export default {"gap8":"SearchBarActions-module__gap8--htEVL","buttons":"SearchBarActions-module__buttons--N7M2V"};